import { render, staticRenderFns } from "./VisitorRegister.vue?vue&type=template&id=5f037c38&scoped=true"
import script from "./VisitorRegister.vue?vue&type=script&lang=js"
export * from "./VisitorRegister.vue?vue&type=script&lang=js"
import style0 from "./VisitorRegister.vue?vue&type=style&index=0&id=5f037c38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f037c38",
  null
  
)

export default component.exports